import { Info, Right } from '@icon-park/react'

import { ElementType, useMemo } from 'react'

import { Flex, IconTooltip } from '@/components'

import { Container, ContainerName, HealthCheckStatus, LinksContainer } from './ManualCard.styles'

import { HealthStatus } from '@/pages'

interface ManualCardProps {
  icon: ElementType
  title: string
  tooltip?: string
  healthCheck?: HealthStatus | boolean
  description?: string
  linkName?: string
  linkAction?: () => void
}

export function ManualCard({
  icon: Icon,
  tooltip,
  title,
  healthCheck,
  description,
  linkName,
  linkAction,
}: ManualCardProps) {
  const finalStatus = useMemo(() => {
    if (healthCheck === undefined) return undefined
    if (healthCheck === true) return 'success'
    if (healthCheck === false) return 'error'
    return healthCheck
  }, [healthCheck])

  return (
    <Container>
      <ContainerName>
        <Icon size={28} />
        <h4>{title}</h4>
        {tooltip && <IconTooltip tooltipText={tooltip} icon={<Info theme="outline" size={12} />} />}
      </ContainerName>
      <LinksContainer>
        {finalStatus && <HealthCheckStatus $status={finalStatus} />}
        <Flex $type="row" $justify="flex-end" $align="center" $gap={32} $fit>
          {description && <h5 className="tertiary-text">{description}</h5>}
          {linkName && (
            <Flex $type="row" $align="center" $gap={8} onClick={linkAction}>
              <h4 className="link-text">{linkName}</h4>
              <Right className="link-text" size={16} />
            </Flex>
          )}
        </Flex>
      </LinksContainer>
    </Container>
  )
}
